type Verdict = {
  status: 'clear' | 'flag' | 'knockout';
  policy: string;
  wording: string;
};

interface ScreeningPolicyVerdictsProps {
  verdicts?: Verdict[] | null;
}

const STYLES: Record<Verdict['status'], string> = {
  clear:
    'bg-green-50 dark:bg-green-900/20 text-green-800 dark:text-green-300 border-green-200 dark:border-green-800',
  flag:
    'bg-amber-50 dark:bg-amber-900/20 text-amber-800 dark:text-amber-300 border-amber-200 dark:border-amber-800',
  knockout:
    'bg-red-50 dark:bg-red-900/20 text-red-800 dark:text-red-300 border-red-200 dark:border-red-800',
};

export function ScreeningPolicyVerdicts({ verdicts }: ScreeningPolicyVerdictsProps) {
  if (!verdicts || verdicts.length === 0) return null;

  return (
    <div className="flex flex-col gap-1.5" data-testid="screening-policy-verdicts">
      {verdicts.map((v, i) => (
        <span
          key={i}
          className={`inline-flex items-center rounded-md border px-2 py-1 text-xs font-medium ${STYLES[v.status]}`}
          data-testid={`screening-policy-verdict-${v.status}`}
        >
          <span className="font-semibold uppercase mr-2">{v.policy}</span>
          <span>{v.wording}</span>
        </span>
      ))}
    </div>
  );
}
